export { default } from './FloatingHelperContent';
